import { Box, Button, Typography } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { BackdropLoader } from 'components/@shared/Loaders';
import { CreateHomePageForm } from 'components/Home/CreateHomePageForm';
import { ONLY_ADMIN } from 'constants/roles';
import { useDeniedAccess } from 'hooks/useDeniedAccess';
import { useDidMount } from 'hooks/useDidMount';
import { useNotifications } from 'hooks/useNotifications';
import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PATH } from 'routes/path';
import { updateHomePage, getHomePageFormData } from 'services/homePageService';
import { HomePageFormData } from 'types/home-page';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};

export const AdminEditHomeImagesPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState<HomePageFormData>();

    const notifications = useNotifications();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const updateHandler = useCallback(
        (form: HomePageFormData) => {
            if (id) {
                setIsLoading(true);
                updateHomePage(form, id)
                    .then(() => {
                        notifications.show({ message: 'Home page successfully updated' });
                        navigate(PATH.ADMIN_SETTINGS_HOME_PAGE);
                    })
                    .finally(() => setIsLoading(false));
            }
        },
        [id],
    );

    useDidMount(() => {
        if (id) {
            setIsLoading(true);
            getHomePageFormData(id)
                .then(setFormData)
                .finally(() => setIsLoading(false));
        }
    });

    useDeniedAccess(ONLY_ADMIN);

    return (
        <Box width="100%" px={2.5} py={2}>
            {formData && (
                <Card title="Edit Home Page" sx={cardStyles}>
                    <CreateHomePageForm initialData={formData} onCreate={updateHandler} />
                </Card>
            )}
            {isLoading && <BackdropLoader />}
        </Box>
    );
};
